/**************************************************************************************************/
/*   File: /src/app/stores/reducers/details/reducer.ts                                             */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Tue May 14 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import * as _ from 'lodash';

import * as fromShared from '../../../shared';
import * as fromActions from '../../actions';
import * as fromStates from '../../states';

/**
 * the dossier state reducer
 * @param state The state
 * @param action The action
 */
export function detailsReducer(
    state: fromStates.fromDetails.DetailsState = fromStates.fromDetails.INITIAL_DOSSIER_DETAILS_STATE,
    action: fromActions.fromDetails.DossierDetailsActions |
        fromActions.fromMessages.MessagesActions |
        any): fromStates.fromDetails.DetailsState {

    switch (action.type) {
        // Reducer for check dossier status
        case fromActions.fromDetails.DossierDetailsActionsType.CHECK_DOSSIER_STATUS:
            return {
                ...state,
                isLoading: true
            };
        // Reducer for check dossier status success
        case fromActions.fromDetails.DossierDetailsActionsType.CHECK_DOSSIER_STATUS_SUCCESS:
            return {
                ...state,
                dossierStatus: action.payload.status,
                isLoading: false
            };
        // Reducer for check dossier status fail
        case fromActions.fromDetails.DossierDetailsActionsType.CHECK_DOSSIER_STATUS_FAIL:
            return {
                ...state,
                messages: [
                    action.payload.message
                ],
                isLoading: false
            };
        // Reducer for load dossier
        case fromActions.fromDetails.DossierDetailsActionsType.LOAD_DOSSIER:
            return {
                ...state,
                isLoading: true
            };
        // Reducer for check dossier status success
        case fromActions.fromDetails.DossierDetailsActionsType.LOAD_DOSSIER_SUCCESS:
            return {
                ...state,
                dossier: {
                    ...action.payload.dossier
                },
                isLoading: false
            };
        // Reducer for check dossier status fail
        case fromActions.fromDetails.DossierDetailsActionsType.LOAD_DOSSIER_FAIL:
            return {
                ...state,
                messages: [
                    action.payload.message
                ],
                isLoading: false
            };
        // Reducer for load initial state
        case fromActions.fromDetails.DossierDetailsActionsType.LOAD_INITIAL_STATE:
            return { ...fromStates.fromDetails.INITIAL_DOSSIER_DETAILS_STATE};

        // Reducer for notify message
        case fromActions.fromMessages.MessagesActionsType.NOTIFY_MESSAGE:
            return action.payload.message.stateName === fromStates.fromDetails.STATE_NAME ?
                {
                    ...state,
                    messages: [
                        ...state.messages,
                        action.payload.message
                    ]
                } : { ...state };
        // Reducer for message removed
        case fromActions.fromMessages.MessagesActionsType.REMOVE_MESSAGE_ACTION:
            return {
                ...state,
                messages: [...state.messages.filter(x => x !== action.payload.message)]
            };
        case fromActions.fromUi.UiActionTypes.UNSET_LOGGED_USER:
            return {
                ...fromStates.fromDetails.INITIAL_DOSSIER_DETAILS_STATE
            };
        case fromActions.fromDetails.DossierDetailsActionsType.LOAD_DOSSIER_PUBLIC:
                return {
                    ...state,
                    isLoading: true
                }
        default:
            return state;
    }
}

// Helpers
/**
 * The getIsLoading function helper
 * @param state The state
 */
const getIsLoading = (state: fromStates.fromDetails.DetailsState) => state.isLoading;
/**
 * The getIsValidating function helper
 * @param state The state
 */
const getIsValidating = (state: fromStates.fromDetails.DetailsState) => state.isValidating;
/**
 * The getIsValidated function helper
 * @param state The state
 */
const getIsValidated = (state: fromStates.fromDetails.DetailsState) => state.isValidated;
/**
 * The getIsLoaded function helper
 * @param state The state
 */
const getIsLoaded = (state: fromStates.fromDetails.DetailsState) => state.isLoaded;
/**
 * The get messages helper function
 * @param state The state
 */
const getMessages = (state: fromStates.fromDetails.DetailsState) => state.messages;
/**
 * Get the dossier details
 * @param state The state
 */
const getDossier = (state: fromStates.fromDetails.DetailsState) => state.dossier;

const getDossierPublic =(state: fromStates.fromDetails.DetailsState)=> state.dossier;

/**
 * Get the dossier id
 * @param state The state
 */
const getDossierId = (state: fromStates.fromDetails.DetailsState) => state.dossierId;
/**
 * Get the dossier status
 * @param state The state
 */
const getDossierStatus = (state: fromStates.fromDetails.DetailsState) =>
    state &&
        state.dossier &&
        state.dossier.summary &&
        state.dossier.summary.status
        ? state.dossier.summary.status
        : undefined;

/**
 * The helpers
 */
export const helpers = {
    getIsLoading,
    getIsValidating,
    getIsValidated,
    getIsLoaded,
    getMessages,
    getDossier,
    getDossierId,
    getDossierStatus,
    getDossierPublic
};
